const messages = {
  "Algolia.GlobalSearch.Heading": "の検索結果",
  "Algolia.GlobalSearch.TextField.Placeholder": "何をお探しですか",
  "Algolia.GlobalSearch.SearchButton.Text": "検索",
  "Algolia.GlobalSearch.EventType.Label": "の検索結果",
  "Algolia.GlobalSearch.ItemsPerPage.Label": "検索結果の表示件数",
  "Algolia.GlobalSearch.Meta.Text": "{count} の検索結果",

  "Algolia.SearchPage.Heading": "SAFの留学プログラム",
  "Algolia.SearchPage.TextField.Placeholder": "キーワードでプログラムを検索する",
  "Algolia.SearchPage.Filters.Label": "フィルター",
  "Algolia.SearchPage.ClearButton.Label": "すべてクリア",
  "Algolia.SearchPage.ProgramType.Label": "プログラムの種類",
  "Algolia.SearchPage.DeliveryMethod.Label": "授業形式",
  "Algolia.SearchPage.HousingType.Label": "滞在形式",
  "Algolia.SearchPage.AcademicLevel.Label": "履修レベル",
  "Algolia.SearchPage.UniversityName.Label": "大学名",
  "Algolia.SearchPage.Select.Placeholder": "入力を開始するか、選択してください",
  "Algolia.SearchPage.UniversityRanking.Label": "大学ランキング",
  "Algolia.SearchPage.AcademicDiscipline.Label": "学部・学科",
  "Algolia.SearchPage.Regions.Label": "地域",
  "Algolia.SearchPage.SubregionsCities.Label": "小地域と都市",
  "Algolia.SearchPage.LanguageOfInstruction.Label": "教授言語",
  "Algolia.SearchPage.languagePrerequisiteLevel.Label": "事前に必要な言語レベル",
  "Algolia.SearchPage.GPARequirements.Label": "必要なGPA",
  "Algolia.SearchPage.TermType.Label": "学期の種類",
  "Algolia.SearchPage.ProgramFees.Label": "プログラム費用",
  "Algolia.SearchPage.SearchButton.Title": "プログラムを検索する",
  "Algolia.SearchPage.ResultsMeta": '{count} のプログラム結果',
  "Algolia.SearchPage.SortBy.Label": "並び替え",
  "Algolia.SearchPage.SortBy.Relevancy.option": "関連性",
  "Algolia.SearchPage.SortBy.Newest.option": "最新",
  "Algolia.SearchPage.CreditPrograms.Label": "現地単位があるプログラムのみを見る",
  "Algolia.SearchPage.HousingType.Tooltip": "[滞在形式：ヒント]検討している滞在形式はありますか？ここから滞在形式でフィルターをかけてください。",
  "Algolia.SearchPage.languagePrerequisiteLevel.Tooltip": "[事前に必要な語学力レベル：ヒント]あなたの語学力レベルに適したプログラムをお探しですか？ ここから語学力レベルでフィルターをかけてください。",
  "Algolia.SearchPage.GPARequirements.Tooltip": "[必要なGPA：ヒント]あなたの成績に適したプログラムをお探しですか？ ここからGPAレベルでフィルターをかけてください。",
  "Algolia.SearchPage.ProgramFees.Tooltip": "[プログラム費用（最安値）：ヒント]検討している予算はありますか？ 検索範囲を広げるには、複数選択してください。",

  "Pager.Current.MetaCurrent": "現在のページ",
  "Pager.First.MetaFirst": "最初のページを見る",
  "Pager.Last.MetaLast": "最後のページを見る",
  "Pager.Next.MetaTitle": "次のページを見る",
  "Pager.Next.TextFull": "次のページ",
  "Pager.Next.Text": "次へ",
  "Pager.Page.MetaPageNumber": "{page} のページを見る",
  "Pager.Page.VisuallyHidden": "ページ",
  "Pager.Previous.MetaTitle": "前のページを見る",
  "Pager.Previous.TextFull": "前のページ",
  "Pager.Previous.Text": "前へ",

  "ProgramCard.Label.None": "なし",
  "ProgramCard.EstimatedCost.Label": "見積り費用",
  "ProgramCard.CTA.Label": "プログラム詳細",
  "ProgramCard.GPARequirements.Label": "推奨GPA (大学によっては交渉可能な場合あり)",
  "ProgramCard.LanguageOfInstruction.Label": "教授言語",
  "ProgramCard.LanguageRequirements.Label": "必要な語学力",
  "ProgramCard.Status.Label": "プログラムは中断されました",

  "ProgramQuickView.Length.Label": "期間",
  "ProgramQuickView.Options.Label": "授業形式",
  "ProgramQuickView.ReadMore.CTA": "さらに読む",
  "ProgramQuickView.ProgramDetails.CTA": "プログラム詳細を見る",
  "ProgramQuickView.ApplyNow.CTA": "SAF出願の流れを確認",
  "ProgramQuickView.AtGlance.Label": "一覧",
  "ProgramQuickView.LanguageInstruction.Label": "教授言語",
  "ProgramQuickView.LanguageRequirements.Label": "必要な語学力",
  "ProgramQuickView.languagePrerequisiteLevel.Label": "事前に必要な言語レベル",
  "ProgramQuickView.GPA.Label": "推奨GPA (大学によっては交渉可能な場合あり)",
  "ProgramQuickView.AcademicLevel.Label": "学術レベル",
  "ProgramQuickView.Credits.Label": "単位",
  "ProgramQuickView.AcademicStrengths.Label": "注目の学部・学科",
  "ProgramQuickView.Housing.Label": "滞在先",
  "ProgramQuickView.Internship.Label": "パートタイムインターンシップ（オプション）",
  "ProgramQuickView.Visa.Label": "ビザの必要性",

  "ProgramSelector.BlockTitle": "最適なプログラムを探す",
  "ProgramSelector.BlockDescription": "留学先を選ぶ際、 留学先（地域）、留学先大学、特定のプログラムタイプ、どれを優先に考えてお探しですか。",
  "ProgramSelector.BlockLink": "すべてのプログラムを見る",
  "ProgramSelector.Destinations.BlockDescription": "最も関心のある地域を選択する",
  "ProgramSelector.Destinations.BlockQuestion": "どこで勉強したいですか？",
  "ProgramSelector.Destinations.AllDestinations.Label": "全ての留学先（地域）",
  "ProgramSelector.Destinations.Destinations.Label": "留学先の地域・都市",
  "ProgramSelector.Universities.BlockDescription": "興味のある大学をすべて選択してください",
  "ProgramSelector.Universities.BlockQuestion": "どの大学で勉強したいですか？",
  "ProgramSelector.Universities.Universities.Label": "大学",
  "ProgramSelector.TypeOfStudy.TypeOfStudy.Label": "研究の種類",
  "ProgramSelector.TypeOfStudy.BlockDescription": "興味のある全ての研究の種類を選択してください",
  "ProgramSelector.TypeOfStudy.BlockQuestion": "どんな種類のプログラムが良いですか？",
  "ProgramSelector.SeePrograms.Label": "私のプログラムを見る",
  "ProgramSelector.BrowsePrograms.Label": "すべてのプログラムを見る",

  "Algolia.SidebarFilters.SelectOrRadios.FirstOption": "全て",
  "Algolia.SearchPage.GPARequirements.Options.None": "なし",
}

export default messages;
